function isFilteredComponent(componentId) {
    try {
        const rules = Array.isArray(window.WCCP_FILTERING_RULES) ? window.WCCP_FILTERING_RULES : [];
        return rules.some(r => r && r.enabled && String(r.component_id) === String(componentId));
    } catch { return false; }
}
function updateStepNavButtons(stepEl) {
        if (!stepEl) return;
        const steps = qsa(selFor(CLASSES.step), root);
        const idx = Number(stepEl.dataset.step) - 1;

        let hasPrev = false, hasNext = false;

        for (let i = idx - 1; i >= 0; i--) {
            if (stepHasVisibleOptions(steps[i])) { hasPrev = true; break; }
        }
        for (let i = idx + 1; i < steps.length; i++) {
            if (stepHasVisibleOptions(steps[i])) { hasNext = true; break; }
        }

        const prevBtn = stepEl.querySelector('.wccp-prev-btn');
        const nextBtn = stepEl.querySelector('.wccp-next-btn');
        if (prevBtn) prevBtn.disabled = !hasPrev;
        if (nextBtn) nextBtn.disabled = !hasNext;

        disableNextButtonIfNoSelection(stepEl);
    }

    const collectSelectionsFromStateOrDOM = () => {
        return { ...STATE.selected };
    };

    async function wccpFetchFilteredComponent(componentId, selections) {

        if (!isFilteredComponent(componentId)) {
            if (window.WCCP_DEV_MODE?.debug?.componentSkip) {
                let baseProducts = [];
                let allowedProducts = [];
                let killedProducts = [];
                let effects = [];
                let step = null;
                let isStepVisible = null;
                let reasonCode = 'no_filtering_rules';
                let reasonLabel = 'Component has no backend filtering rules';

                try {
                    const cid = Number(componentId);
                    const comp =
                        STATE?.data?.components?.find(c => Number(c.id) === cid);

                    if (comp && Array.isArray(comp.products)) {
                        baseProducts = comp.products.map(p => Number(p.product_id));
                    }

                    const allowedSet =
                        computeAllowedByComponent()?.get(cid) || new Set();

                    allowedProducts = [...allowedSet];
                    killedProducts = baseProducts.filter(
                        pid => !allowedSet.has(pid)
                    );

                    effects =
                        window.WCCP_DEBUG?.scenarioEffectsByComponent?.[cid] || [];

                             const stepEl = document.querySelector(`[data-item_id="${cid}"]`);
                    if (stepEl) {
                        step = Number(stepEl.dataset.step);
                        isStepVisible = stepEl.style.display !== 'none';
                    }

                    if (baseProducts.length && !allowedProducts.length) {
                        reasonCode = 'scenario_killed_all_products';
                        reasonLabel = 'All products were removed by frontend scenarios';
                    }

                    if (
                        effects.some(e =>
                        e.effect.includes('hide_components')
                    )
                    ) {
                        reasonCode = 'component_hidden_by_scenario';
                        reasonLabel = 'Component hidden by scenario';
                    }
                
                } catch (e) {
                // never break constructor because of dev log
                }

                devLog('FILTER_COMPONENT_SKIP', {
                    // step,
                    // is_step_visible: isStepVisible,
                    // dev_ignore_hiding: devIgnoreHiding(),
                    component_id: Number(componentId),
                    // reason: 'component has no filtering rules',
                    reason_code: reasonCode,
                    reason: reasonLabel,
                    base_product_ids: baseProducts,
                    allowed_product_ids: allowedProducts,
                    killed_product_ids: killedProducts,
                    scenario_effects: effects
                });
            }

            return { products: [] };
        }

        let json = null;
        const prefetchKey = filterRequestKey(componentId, selections);
        const prefetched = FILTER_PREFETCH.get(prefetchKey);
        if (prefetched) {
            FILTER_PREFETCH.delete(prefetchKey);
            window.WCCP_LOADING?.start(); // only visible if the prefetch is still in flight
            try { json = await prefetched; } finally { window.WCCP_LOADING?.stop(); }
        }

        if (!json) json = await wccpPost(filterRequestBody(componentId, selections)); // throws on network failure; tryNarrowComponentById handles it
        if (!json || !json.success) return null;

        // The filter response carries what wccp_get_variations returns for this component's products
        // (picked and not yet picked), so the follow-up variations request can be skipped.
        if (json.data && Array.isArray(json.data.variation_items)) {
            prefillVariationItems(componentId, selections, json.data.variation_items, 'picked');
            prefillVariationItems(componentId, selections, json.data.variation_items_unpicked || [], 'none');
        }

        if (json.data && json.data.preselect && json.data.preselect.product_id) {
            window.WCCP_PRESELECT[Number(componentId)] = {
                product_id: Number(json.data.preselect.product_id),
                variation_id: json.data.preselect.variation_id ? Number(json.data.preselect.variation_id) : undefined
            };
        }

        return json.data;

    }

    function filterRequestBody(componentId, selections) {
        const body = new URLSearchParams();
        body.set('action', 'wccp_get_filtered_component');
        body.set('component_id', componentId);
        const nonce = (window.cdi_door_filter_ajax && window.cdi_door_filter_ajax.nonce) || '';
        if (nonce) body.set('door_filter_nonce', nonce);

        Object.entries(selections || {}).forEach(([k, v]) => {
            if (v !== undefined && v !== null) body.set(`selections[${k}]`, String(v));
        });
        return body;
    }

    // Same component + same selections (in the order they are sent) = same server response.
    function filterRequestKey(componentId, selections) {
        const entries = Object.entries(selections || {})
            .filter(([, v]) => v !== undefined && v !== null)
            .map(([k, v]) => [k, String(v)]);
        return `${Number(componentId)}:${JSON.stringify(entries)}`;
    }

    // Speculative filter prefetch. While the customer looks at a step, resolve in the background the filter request
    // the builder will make right after each option is picked (e.g. the door after Fire Rating), so the next step
    // shows without a round trip. A prefetched response is only used when the real request's selections match it
    // exactly; otherwise the builder requests as usual.
    const FILTER_PREFETCH = new Map();

    // Replays what goNext()/autoSelectAndSkipIfSingle() do after `pid` is picked on `stepEl`: components with no
    // allowed option are cleared, single-option ones auto-selected, and the first filtered component is the request.
    // Stops (null) at a step the customer must answer or an admin-hidden step (its preselect logic is not replayed).
    function predictNextFilterRequest(stepEl, pid) {
        const steps = qsa(selFor(CLASSES.step), root);
        const from = steps.indexOf(stepEl);
        const realSelected = STATE.selected;
        const saved = [LAST_MATCHED_SCENARIOS, LAST_HIDDEN_COMPONENTS];
        STATE.selected = { ...realSelected, [Number(stepEl.dataset.item_id)]: pid };
        try {
            for (let i = from + 1; i < steps.length; i++) {
                const cid = Number(steps[i].dataset.item_id);
                if (isHiddenStep(steps[i])) return null;
                if (isFilteredComponent(cid) && steps[i].dataset.narrowApplied !== '1'
                    && stepNeedsNarrowing(steps[i]) && !isComponentHiddenByScenarios(cid)) {
                    return { componentId: cid, selections: { ...STATE.selected } };
                }
                const allowed = computeAllowedByComponent().get(cid) || new Set();
                const opts = qsa(selFor(CLASSES.option), steps[i]).filter(o => allowed.has(Number(o.dataset.productId)));
                if (opts.length > 1) return null;
                if (opts.length === 1) STATE.selected[cid] = Number(opts[0].dataset.productId);
                else delete STATE.selected[cid];
            }
            return null;
        } finally {
            STATE.selected = realSelected;
            [LAST_MATCHED_SCENARIOS, LAST_HIDDEN_COMPONENTS] = saved;
        }
    }

    // Option images are lazy-loaded: the page holds every option of every step (~2,700 images, 20-34 MB) and
    // most sit in hidden steps. While the customer looks at a step, start loading the images of the next step they
    // will actually see (skipping steps hidden by scenarios and single-option ones the builder auto-selects, whose
    // image is warmed too), allowed options only. One step ahead: some steps hold animated GIFs of several MB.
    function warmUpcomingStepImages(stepEl) {
        const steps = qsa(selFor(CLASSES.step), root);
        const allowedBy = computeAllowedByComponent();
        for (let i = steps.indexOf(stepEl) + 1; i < steps.length; i++) {
            const allowed = allowedBy.get(Number(steps[i].dataset.item_id)) || new Set();
            const imgs = qsa(selFor(CLASSES.option), steps[i])
                .filter(o => allowed.has(Number(o.dataset.productId)))
                .map(o => o.querySelector('img[loading="lazy"]'))
                .filter(Boolean);
            if (imgs.length > 24) continue; // long lists (every door size) are narrowed to a few before they show
            imgs.forEach(img => { img.loading = 'eager'; });
            if (allowed.size > 1) return;
        }
    }

    function prefetchFiltersForStep(stepEl) {
        if (!stepEl) return;
        warmUpcomingStepImages(stepEl);
        if (NARROW_DISABLED) return;
        const cid = Number(stepEl.dataset.item_id);
        const allowed = computeAllowedByComponent().get(cid) || new Set();
        const opts = qsa(selFor(CLASSES.option), stepEl).filter(o => allowed.has(Number(o.dataset.productId)));
        if (opts.length > 12) return; // long lists (sizes, doors) are not worth a request per option
        // One option per task so the simulation never holds the main thread while the customer is clicking;
        // stop once the step is no longer on screen.
        const queue = opts.map(o => Number(o.dataset.productId));
        const runNext = () => {
            if (!queue.length || !stepEl.offsetParent) return;
            prefetchFilterAfterPick(stepEl, queue.shift());
            setTimeout(runNext, 0);
        };
        setTimeout(runNext, 50);
    }

    function prefetchFilterAfterPick(stepEl, pid) {
        const next = predictNextFilterRequest(stepEl, pid);
        if (!next) return;
        const key = filterRequestKey(next.componentId, next.selections);
        if (FILTER_PREFETCH.has(key)) return;
        const body = filterRequestBody(String(next.componentId), next.selections);
        body.set('prefetch', '1'); // keeps the loading overlay off (see ui/overlay.js)
        const url = (window.cdi_door_filter_ajax && window.cdi_door_filter_ajax.ajax_url) || '/wp-admin/admin-ajax.php';
        FILTER_PREFETCH.set(key, fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString()
        }).then(r => (r.ok ? r.json() : null)).catch(() => null));
    }

    (function attachFilterDebug(){
        if (window.__WCCP_FILTER_DEBUG__) return;
        window.__WCCP_FILTER_DEBUG__ = true;

        const orig = window.wccpFetchFilteredComponent;
        if (typeof orig !== 'function') return;

        window.wccpFetchFilteredComponent = async function(componentId, selections) {
            window.WCCP_DEV_CONSOLE?.log("BACKEND_FILTER_REQUEST", {
            component_id: componentId,
            selections: JSON.parse(JSON.stringify(selections))
            });

            const res = await orig.apply(this, arguments);

            window.WCCP_DEV_CONSOLE?.log("BACKEND_FILTER_RESULT", {
            component_id: componentId,
            product_ids: res?.products?.map(p => p.product_id),
            preselect: res?.preselect || null
            });

            return res;
        };
        })();


    async function tryNarrowComponentById(componentId) {
        const comp = (STATE.data?.components || []).find(c => Number(c.id) === Number(componentId));
        if (!comp) return false;

        const selections = collectSelectionsFromStateOrDOM();
        const key = narrowKey(componentId, selections);
        if (NARROW_CACHE.has(key)) {
            return Boolean(NARROW_RESULT.get(key));
        }

        if (NARROW_INFLIGHT.has(componentId)) {
            await NARROW_INFLIGHT.get(componentId);
            if (NARROW_RESULT.has(key)) NARROW_CACHE.add(key);
            return Boolean(NARROW_RESULT.get(key));
        }

        let failed = false;
        const inflight = (async () => {
            let data;
            try {
                data = await wccpFetchFilteredComponent(String(componentId), selections);
            } catch (e) {
                // Network failure after retries: don't cache it, so a retry asks again; narrowIfNeededForStep handles the UI.
                failed = true;
                throw e;
            }

            if (!data || !Array.isArray(data.products) || !data.products.length) {
                if (window.WCCP_DEV_MODE?.debug?.variationSkip) {
                    devLog('VARIATION_FILTER_NOT_APPLIED', {
                        component_id: componentId,
                        requested_product_ids: (comp.products || []).map(p => p.product_id),
                        selections: selections,
                        reason: 'Backend returned no products for variation filtering',
                        source: 'tryNarrowComponentById'
                    });
                }
                NARROW_RESULT.set(key, false);
                return false;
            }

            const currentIds = new Set(
                (comp.products || [])
                    .map(p => Number(p.product_id ?? p.id ?? p.ID))
                    .filter(n => Number.isFinite(n))
            );

            const incomingList = (data.products || []).map(p => {
                const pid = Number(p.product_id ?? p.id ?? p.ID);
                return {
                    product_id: pid,
                    name: p.name || '',
                    thumbnail_url: p.thumbnail_url || '',
                    thumb:p.thumb || '',
                    is_variable: !!p.is_variable,
                    variations: Array.isArray(p.variations) ? p.variations : []
                };
            });

            const incomingIds = new Set(
                incomingList.map(p => p.product_id).filter(n => Number.isFinite(n))
            );

            const incomingIsSubset = [...incomingIds].every(id => currentIds.has(id));
            const fewer = incomingIds.size < currentIds.size;

            let didNarrow = false;

            if (fewer || incomingIsSubset) {
                didNarrow = true;
                comp.products = incomingList;
            } else {
                const map = new Map((comp.products || []).map(p => [Number(p.product_id ?? p.id ?? p.ID), p]));
                incomingList.forEach(np => {
                    const p = map.get(np.product_id);
                    if (!p) return;
                    if (np.variations && np.variations.length) p.variations = np.variations;
                    if (typeof np.is_variable === 'boolean') p.is_variable = np.is_variable;
                });
                didNarrow = false;
            }

            if (!didNarrow && window.WCCP_DEV_MODE?.debug?.variationSkip) {
                devLog('VARIATION_FILTER_NOT_APPLIED', {
                    component_id: componentId,
                    reason: 'backend returned products but did not narrow',
                    before_product_ids: [...currentIds],
                    after_product_ids: [...incomingIds],
                    source: 'tryNarrowComponentById'
                });
            }


            NARROW_RESULT.set(key, didNarrow);
            return didNarrow;
        })();

        NARROW_INFLIGHT.set(componentId, inflight);
        try {
            const res = await inflight;
            return res;
        } finally {
            NARROW_INFLIGHT.delete(componentId);
            if (!failed) NARROW_CACHE.add(key);
        }
    }

    function getComponentById(cid) {
        return (STATE.data?.components || []).find(c => Number(c.id) === Number(cid));
    }

    // The step's filter request failed even after retries. Its unfiltered list (e.g. ~1,250 doors of every size)
    // must not be pickable, so hide it and offer a retry instead.
    function showNarrowFailed(stepEl) {
        hideBuilderNetworkError();
        // Drop any pick or preselect for it too: none came from a filtered list, and "Next" stays enabled while one exists.
        const cid = Number(stepEl.dataset.item_id);
        delete STATE.selected[cid];
        if (STATE.selectedVariants) delete STATE.selectedVariants[cid];
        if (window.WCCP_PRESELECT) delete window.WCCP_PRESELECT[cid];
        disableNextButtonIfNoSelection(stepEl);
        const options = stepEl.querySelector('.component_options');
        if (options) options.style.display = 'none';
        if (stepEl.querySelector('.wccp-narrow-failed')) return;
        const box = document.createElement('div');
        box.className = 'wccp-narrow-failed';
        box.setAttribute('role', 'alert');
        box.style.cssText = 'margin:12px 0;padding:12px 14px;border:1px solid #e0b4b4;background:#fff6f6;color:#9f3a38;border-radius:4px;';
        box.textContent = "We couldn't load these options. Please check your connection. ";
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.textContent = 'Try again';
        retry.addEventListener('click', async () => {
            await narrowIfNeededForStep(stepEl);
            if (!stepEl.querySelector('.wccp-narrow-failed')) {
                await ensureVariationsForStep(stepEl);
                updateStepNavButtons(stepEl);
            }
        });
        box.appendChild(retry);
        (options ? options.parentNode : stepEl).insertBefore(box, options || null);
    }

    function clearNarrowFailed(stepEl) {
        const box = stepEl.querySelector('.wccp-narrow-failed');
        if (!box) return;
        box.remove();
        const options = stepEl.querySelector('.component_options');
        if (options) options.style.display = '';
    }

    async function narrowIfNeededForStep(stepEl) {
        if (NARROW_DISABLED) return;
        if (!stepEl) return;
        if (NARROW_SUSPENDED) return;
        if (!stepNeedsNarrowing(stepEl)) return;

        const componentId = Number(stepEl.dataset.item_id);

        if (stepEl.dataset.narrowApplied === '1') return;
        // Hidden by the matched scenarios: the builder will skip it whatever the filter returns, so save the ~1 s round trip.
        if (isComponentHiddenByScenarios(componentId)) return;

        let didNarrow;
        try {
            didNarrow = await tryNarrowComponentById(componentId);
        } catch (e) {
            showNarrowFailed(stepEl);
            return;
        }
        clearNarrowFailed(stepEl);

        if (didNarrow) {
            const comp = getComponentById(componentId);
            if (comp && Array.isArray(comp.products)) {
                renderComponentOptions(stepEl, comp.products);
                /*** DEBUG ***/
                // window.afterWccpStepDomRender();
            }
            stepEl.dataset.narrowApplied = '1';
            updateStepNavButtons(stepEl);
        }
    }